import { ROUTES } from './routes';
import authService from '../services/authService';

export const HOME_PERSONA_SUBTITLES = {
  graphiste: 'Vos créas et le chemin de fer magazine.',
  responsable_mag: 'Sommaire, chemin de fer et alertes magazine.',
  admin_commercial: 'Planning, chiffrage et suivi commercial.',
  commercial: 'Voici vos raccourcis Koikispass et prospection.',
  prod: 'Vos tâches de la semaine.',
  tm: 'Répartition des tâches de production.',
  admin: 'Administration et modules du portail.',
  default: 'Accédez à vos outils métier depuis un seul endroit.',
};

export const HOME_MULTI_ROLE_SUBTITLE = 'Voici les raccourcis de vos métiers.';

/**
 * Raccourcis métier (filtrés ensuite par menuVisibilityService.canSee).
 * `roles` : métiers pour lesquels le raccourci fait partie du cockpit.
 * L’ordre du tableau est l’ordre d’affichage (union, sans doublon).
 */
export const HOME_SHORTCUTS = [
  {
    id: 'crea-pub',
    label: 'Suivi créa pub',
    description: 'Publicités à produire',
    icon: 'mdi:palette-outline',
    to: ROUTES.kkp.cdfPubGraphiste,
    menuKey: 'page.kkp.cdfPubGraphiste',
    roles: ['graphiste'],
  },
  {
    id: 'cdf-mag',
    label: 'Chemin de fer MAG',
    description: 'Suivi production magazine',
    icon: 'mdi:train-car',
    to: ROUTES.kkp.cdfMag,
    menuKey: 'page.kkp.cdfMag',
    roles: ['graphiste', 'responsable_mag'],
  },
  {
    id: 'sommaire-mag',
    label: 'Sommaire MAG',
    description: 'Sommaire magazine',
    icon: 'mdi:book-open-page-variant',
    to: ROUTES.kkp.sommaireMag,
    menuKey: 'page.kkp.sommaireMag',
    roles: ['responsable_mag'],
  },
  {
    id: 'alertes-mails',
    label: 'Alertes mails',
    description: 'Crons & notifications',
    icon: 'mdi:email-alert-outline',
    to: ROUTES.kkp.crons,
    menuKey: 'page.kkp.crons',
    roles: ['responsable_mag'],
  },
  {
    id: 'planning-mag',
    label: 'Planning MAG',
    description: 'Ventes magazine',
    icon: 'mdi:calendar-month',
    to: ROUTES.kkp.planningMag,
    menuKey: 'page.kkp.planningMag',
    roles: ['commercial', 'admin_commercial'],
  },
  {
    id: 'chiffrage-kkp',
    label: 'Chiffrage Koikispass',
    description: 'Plan de com & BDC',
    icon: 'mdi:file-document-edit-outline',
    to: ROUTES.kkp.planDeCom,
    menuKey: 'page.kkp.planDeCom',
    roles: ['commercial', 'admin_commercial'],
  },
  {
    id: 'secteurs',
    label: 'Dashboard Secteurs',
    description: 'Prospection & territoires',
    icon: 'mdi:map-marker-radius',
    to: ROUTES.secteurs.dashboard,
    menuKey: 'page.secteurs.dashboard',
    roles: ['commercial', 'admin_commercial'],
  },
  {
    id: 'depots',
    label: 'Dépôts',
    description: 'Fichiers à déposer / relire',
    icon: 'mdi:folder-upload-outline',
    to: ROUTES.depots,
    menuKey: 'page.depotRdv',
    roles: ['commercial', 'admin_commercial'],
  },
  {
    id: 'kkp-admin',
    label: 'Administration Koikispass',
    description: 'Référentiels magazine',
    icon: 'mdi:cog-outline',
    to: ROUTES.kkp.admin,
    menuKey: 'page.kkp.admin',
    roles: ['admin_commercial'],
  },
  {
    id: 'temps-taches',
    label: 'Mes tâches',
    description: 'Tâches de la semaine',
    icon: 'mdi:checkbox-marked-circle-outline',
    to: ROUTES.temps.taches,
    menuKey: 'page.temps.taches',
    roles: ['prod', 'tm', 'admin'],
  },
  {
    id: 'temps-pilotage',
    label: 'Pilotage',
    description: 'Répartir les tâches prod',
    icon: 'mdi:clipboard-check-outline',
    to: ROUTES.temps.pilotage,
    menuKey: 'page.temps.pilotage',
    roles: ['tm', 'admin'],
  },
  {
    id: 'admin-users',
    label: 'Utilisateurs',
    description: 'Gestion des comptes',
    icon: 'mdi:account-cog',
    to: ROUTES.admin.users,
    menuKey: 'page.admin.users',
    roles: ['admin'],
  },
];

/** Items « À traiter » (compteurs), limités au métier. */
export const HOME_TODO_ITEMS = [
  {
    id: 'depots-pending',
    label: 'Dépôts à relire',
    description: 'Fichiers en attente de validation',
    icon: 'mdi:folder-alert-outline',
    to: ROUTES.depots,
    menuKey: 'page.depotRdv',
    countKey: 'depotPending',
    roles: ['commercial', 'admin_commercial'],
  },
  {
    id: 'crea-pub-pending',
    label: 'Pubs à faire',
    description: 'Créas publicitaires en attente',
    icon: 'mdi:palette-swatch-outline',
    to: ROUTES.kkp.cdfPubGraphiste,
    menuKey: 'page.kkp.cdfPubGraphiste',
    countKey: 'pubGraphiste',
    roles: ['graphiste'],
  },
];

/**
 * Métiers du compte (union). Le superadmin sans autre métier reçoit le pack admin.
 */
export function resolveHomeRoles() {
  const roles = [];
  if (authService.isGraphiste()) roles.push('graphiste');
  if (authService.hasRole('ROLE_RESPONSABLE_MAG')) roles.push('responsable_mag');
  if (authService.isAdminCommercial()) roles.push('admin_commercial');
  if (authService.hasRole('ROLE_COMMERCIAL')) roles.push('commercial');
  if (authService.isProd()) roles.push('prod');
  if (authService.hasRole('ROLE_TM_PROJECT_MANAGER')) roles.push('tm');
  if (authService.hasRole('ROLE_ADMIN')) roles.push('admin');
  if (roles.length === 0 && authService.isSuperAdmin()) roles.push('admin');
  return roles;
}

/** Préavis et sites Klub : commercial et admin commercial uniquement. */
export function homeShowsKlubBlocks(roles) {
  return roles.includes('commercial') || roles.includes('admin_commercial');
}

/**
 * Raccourcis du cockpit : union des métiers, filtrés par canSee, ordre du catalogue.
 */
export function getVisibleHomeShortcuts(roles, canSee) {
  const owned = new Set(roles);
  return HOME_SHORTCUTS.filter(
    (item) => item.roles.some((role) => owned.has(role)) && canSee(item.menuKey),
  );
}

/**
 * Compteurs « À traiter » du métier, page autorisée, compteur > 0.
 */
export function getVisibleHomeTodos(roles, canSee, countsByKey) {
  const owned = new Set(roles);
  return HOME_TODO_ITEMS.filter((item) => {
    if (!item.roles.some((role) => owned.has(role))) return false;
    if (!canSee(item.menuKey)) return false;
    return (Number(countsByKey[item.countKey]) || 0) > 0;
  });
}

export function getHomeSubtitle(roles) {
  if (!roles || roles.length === 0) return HOME_PERSONA_SUBTITLES.default;
  if (roles.length > 1) return HOME_MULTI_ROLE_SUBTITLE;
  return HOME_PERSONA_SUBTITLES[roles[0]] || HOME_PERSONA_SUBTITLES.default;
}
